/**
 * If there is an anchor in the URL, scroll to it after 500ms.
 * This fixes links to dynamically loaded anchors
 */
jQuery(document).ready(function () {
    setTimeout(() => {
        var urlHash = window.location.hash;
        if (urlHash && jQuery(urlHash).length)
        jQuery('html,body').animate(
            {
                scrollTop: jQuery(urlHash).offset().top - 90,
            },
            1500
        );
    }, 500);
});